import { Injectable, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  private readonly meta = inject(Meta);
  private readonly PC_MODE_VIEWPORT =
    'width=1400px,user-scalable=no,shrink-to-fit=yes';
  private readonly DEFAULT_VIEWPORT = 'width=device-width,initial-scale=1';

  /**
   * PC版表示用のviewportを設定する
   */
  setForPCMode(): void {
    this.meta.updateTag({
      name: 'viewport',
      content: this.PC_MODE_VIEWPORT,
    });
  }

  /**
   * 通常のモバイル用viewportに戻す
   */
  reset(): void {
    this.meta.updateTag({
      name: 'viewport',
      content: this.DEFAULT_VIEWPORT,
    });
  }
}
